import { FAQsModule } from '@coursera-web/cds-labs';

// Re-export the module as default in order to leverage lazy loading
export default FAQsModule;
